const pending = new Set<() => void>()
let rafId: number | undefined

function flushPending(): void {
  rafId = undefined
  const callbacks = [...pending]
  pending.clear()
  for (const fn of callbacks) {
    fn()
  }
}

export function scheduleDomMeasure(callback: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }

  pending.add(callback)

  if (rafId == null) {
    rafId = window.requestAnimationFrame(flushPending)
  }

  return () => {
    pending.delete(callback)
  }
}
